<template>
  <a-drawer
    :maskClosable="false"
    width="60%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <div>
      <a-form-model ref="form" :model="form" :rules="rules">
        <a-form-model-item label="企业品牌" prop="tenantFirmId" v-if="userType !== 1">
          <a-select
            show-search
            :allowClear="true"
            v-model="form.tenantFirmId"
            placeholder="请选择"
            option-filter-prop="children"
            :filter-option="filterOption"
          >
            <a-select-option v-for="d in userList" :key="d.id">{{ d.name }}</a-select-option>
          </a-select>
        </a-form-model-item>
        <div class="specifications" v-for="(item, index) in form.options">
          <a-form-model-item label="积分设置" prop="ito">
            <a-tree-select
              v-model="item.modelCaliberId"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :tree-data="treeData"
              placeholder="请选择"
              showSearch
              :filterTreeNode="filterFirstLevelNode"
              :treeCheckable="true"
              :treeDefaultExpandAll="false"
              :replaceFields="{ children: 'children', title: 'title', key: 'value', value: 'value' }"
              @change="handleChange($event, index)"
            />
          </a-form-model-item>
          <a-form-model-item :label="userType == 1 ? '经销商金豆' : '分销商金豆'">
            <a-input
              v-model="item.agentIntegral"
              placeholder="请输入"
              :maxLength="20"
              oninput="value=value.replace(/[^\d]/g,'')"
              class="item"
            />
          </a-form-model-item>
          <a-form-model-item label="验收员积分">
            <a-input
              v-model="item.testIntegral"
              placeholder="请输入"
              :maxLength="20"
              oninput="value=value.replace(/[^\d]/g,'')"
              class="item"
            />
          </a-form-model-item>
          <a-form-model-item label="水工积分">
            <div class="item_i">
              <a-input
                v-model="item.waterIntegral"
                placeholder="请输入"
                :maxLength="20"
                oninput="value=value.replace(/[^\d]/g,'')"
                class="item"
              />
            </div>
          </a-form-model-item>
        </div>
        <div class="bottom-control" v-if="isShow">
          <a-space>
            <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
            <a-button type="dashed" @click="cancel"> 取消 </a-button>
          </a-space>
        </div>
      </a-form-model>
    </div>
  </a-drawer>
</template>
<script>
import { publicModel } from '@/api/pressure/mode'
import { addObj } from '@/api/pressure/specifications'
// import Province from '@/components/formModel/Province'
import { listTenant } from '@/api/system/tenant'
import { pageMy } from '@/api/pressure/dispatch'

export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: true,
    },
  },
  components: {
    // Province,
  },
  data() {
    return {
      submitLoading: false,
      data: [],
      treeData: [],
      brandList: [],
      formTitle: '',
      inputValue: '',
      inputValues: '',
      // 表单参数
      form: {
        id: undefined,
        agentIntegral: undefined,
        modelCaliberId: undefined,
        modelId: undefined,
        tenantFirmId: undefined,
        testIntegral: undefined,
        waterIntegral: undefined,
        options: [
          {
            modelCaliberId: undefined,
            agentIntegral: undefined,
            testIntegral: undefined,
            waterIntegral: undefined,
            modelId: undefined,
          },
        ],
      },
      isShow: true,
      open: false,
      inputVisible: false,
      inputVisibles: false,
      modelList: [],
      userList: [],
      rules: {
        tenantFirmId: [{ required: true, message: '请选择企业品牌', trigger: 'blur' }],
        modelCaliberId: [{ required: true, message: '请选择规格', trigger: 'blur' }],
        agentIntegral: [{ required: true, message: '请输入经销商金豆', trigger: 'blur' }],
        testIntegral: [{ required: true, message: '请输入验收员积分', trigger: 'blur' }],
        waterIntegral: [{ required: true, message: '请输入水工积分', trigger: 'blur' }],
      },
    }
  },
  filters: {},
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
    console.log('this.userType', this.userType)
    // this.getQi()
    if (this.userType == 0 || this.userType == 2) {
      this.getMy({ type: 1 }, 1)
    }
    this.getModel()
    console.log(this.userTentant, 'userTentant')
  },
  computed: {
    userType() {
      return this.$store.state.user.userTentant.type
    },
    tenantId() {
      return this.$store.state.user.userTentant.tenantId
    },
  },
  watch: {},
  methods: {
    // 关键：保证只有第一层能被搜到
    filterFirstLevelNode(inputValue, treeNode) {
      // 1. 取到真实数据对象
      const node = treeNode.data?.props || treeNode.props || treeNode.dataRef
      // 2. 非一级直接拒绝
      if (!node || node.level !== 1) return false
      // 3. 空搜索时全部显示
      const search = (inputValue || '').toLowerCase()
      if (!search) return true
      // 4. 模糊匹配
      const text = (node.title || '').toLowerCase()
      return text.includes(search)
    },

    handleFocus(e) {
      console.log('cddddmmm')
      const isVisible = this.$refs.treeSelect
      // console.log('下拉框是否显示:', isVisible);
      // this.isShow = false
      // console.log(this.isShow,'cddddmmm测试===')
    },
    handleBlur(e) {
      console.log('cddddmmm555')
      // const isVisible = this.$refs.treeSelect;
      // console.log('下拉框是否显示444:', isVisible);
      // this.isShow = true
    },
    getMy(query, e) {
      // 厂商经销商
      pageMy(query).then((res) => {
        console.log(res.data.records, '测试====666')
        this.userList = res.data.records
      })
    },
    handleProvince(e, item) {
      // this.queryParam.firmId = e
      item.tenantFirmId = e
      this.$forceUpdate()
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // getModel() {
    //   publicModel({ pageNum: 1, pageSize: 999 }).then((res) => {
    //     this.modelList = res.data.records
    //     const arr = []
    //     res.data.records.forEach((v, index) => {
    //       const children = []
    //       if (v.modelCalibers && v.modelCalibers.length) {
    //         v.modelCalibers.forEach((item, indexs) => {
    //           // 子节点也统一 title/key/value
    //           children.push({
    //             title: item.name,
    //             key: item.id,
    //             value: item.id,
    //             label: item.name // 保留label，兼容原有逻辑
    //           })
    //         })
    //       }
    //       // 第一层节点统一 title/key/value + 保留label
    //       arr.push({
    //         title: v.productName,
    //         key: v.id,
    //         value: v.id,
    //         label: v.productName, // 保留label，避免原有逻辑出错
    //         children: children
    //       })
    //     })
    //     this.treeData = arr
    //     console.log(this.treeData, '的点点滴滴')
    //   })
    // },
    getModel() {
      publicModel({ pageNum: 1, pageSize: 999 }).then((res) => {
        const arr = []
        res.data.records.forEach((v) => {
          const children = (v.modelCalibers || []).map((item) => ({
            title: item.name,
            key: item.id,
            value: item.id,
            level: 2, // 子节点统一打 2
          }))
          arr.push({
            title: v.productName,
            key: v.id,
            value: v.id,
            level: 1, // 第一层打 1
            children,
          })
        })
        this.treeData = arr
      })
    },
    handleDel(index) {
      this.form.options.splice(index, 1)
    },
    onClose() {
      this.open = false
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        agentIntegral: undefined,
        modelCaliberId: undefined,
        modelId: undefined,
        tenantFirmId: undefined,
        testIntegral: undefined,
        waterIntegral: undefined,
        options: [
          {
            modelCaliberId: undefined,
            agentIntegral: undefined,
            testIntegral: undefined,
            waterIntegral: undefined,
            modelId: undefined,
          },
        ],
      }
      this.tags = []
      this.tagslist = []
    },
    /** 新增按钮操作 */
    handleAdd(options) {
      console.log(options, 'optionsoptions')
      this.reset()
      setTimeout(() => {
        if (options && options.length) {
          this.form.options[0].modelCaliberId = options
        }
      }, 0)

      this.open = true
      this.formTitle = '设置单独积分'
    },
    handleAddItem() {
      const options = this.form.options
      const index = options.length - 1
      if (!options[index].modelCaliberId) return this.$message.error('请选择规格')
      if (!options[index].agentIntegral) return this.$message.error('请输入经销商金豆')
      if (!options[index].testIntegral) return this.$message.error('请输入验收员积分')
      if (!options[index].waterIntegral) return this.$message.error('请输入水工积分')
      // if (!options[index].tenantFirmId && this.userType == 2) return this.$message.error('请选择企业品牌')
      // let refM = 'province' + index
      // console.log(refM, 'indexindexindex')
      this.form.options.push({
        modelCaliberId: undefined,
        tenantFirmId: options[index].tenantFirmId,
        agentIntegral: undefined,
        testIntegral: undefined,
        waterIntegral: undefined,
        modelId: undefined,
      })
      setTimeout(() => {
        this.$refs.province.init()
        // this.$nextTick(() => {
        // })
      }, 5000)
      // this.$nextTick(() => {
      //   this.$refs.province.edit(options[index].tenantFirmId)
      // })

      console.log(this.form.options, 'this.form.optionsthis.form.options')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      // const postId = row ? row.id : ids
      // getObj(postId).then((response) => {
      //   console.log(response.data, 'response.data')
      //   // this.tagslist = response.data.productCode.split(',')
      //   // this.tags = response.data.optionalUnit.split(',')
      //   // response.data.modelCaliberAddParams = response.data.modelCalibers
      //   // this.form = response.data
      // })
      this.form.modelCaliberId = row.modelCaliberId
      this.open = true
      this.formTitle = '设置单独积分'
    },
    // 点击树机构发生变化
    handleChange(e, index) {
      console.log(e, '顶顶顶顶')

      this.treeData.forEach((v) => {
        if (v.children && v.children.length) {
          v.children.forEach((item) => {
            if (item.value === e[0]) {
              console.log(v, '测试撒顶顶顶顶')
              this.form.options[index].modelId = v.value
              this.form.modelCaliberId = e
            }
          })
        }
      })
      console.log(this.form, '顶顶顶顶formform')
    },
    // 根据子节点 value 反向拿到父节点 value
    getParentIdByCaliberId(childId) {
      for (const parent of this.treeData) {
        const hit = (parent.children || []).find((c) => c.value === childId)
        if (hit) return parent.value
      }
      return null
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')
      let flage = false
      console.log(this.form.options, ' this.form.options this.form.options')
      const arr = []
      this.form.options.forEach((v) => {
        if (this.userType == 1) {
          v.tenantFirmId = this.tenantId
        } else {
          v.tenantFirmId = this.form.tenantFirmId
        }
        if (!v.modelCaliberId || !v.tenantFirmId || !v.agentIntegral || !v.testIntegral || !v.waterIntegral) {
          flage = true
        }
        if (v.modelCaliberId && v.modelCaliberId.length) {
          console.log(v.modelId, ' v.modelId v.modelId')
          v.modelCaliberId.forEach((item) => {
            console.log(item, '测试item')
            const parentId = this.getParentIdByCaliberId(item)
            arr.push({
              agentIntegral: v.agentIntegral,
              modelCaliberId: item,
              tenantFirmId: v.tenantFirmId,
              testIntegral: v.testIntegral,
              waterIntegral: v.waterIntegral,
              modelId: this.getParentIdByCaliberId(item),
            })
          })
        }
      })
      // if (flage) return this.$message.error('请输入完整的数据')
      this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          // if (this.form.id !== undefined) {
          //   putObj(this.form)
          //     .then((response) => {
          //       this.$message.success('修改成功', 3)
          //       this.open = false
          //       this.$emit('ok')
          //     })
          //     .finally(() => {
          //       this.submitLoading = false
          //     })
          // } else {
          addObj(arr)
            .then((response) => {
              this.$message.success('设置成功', 3)
              this.open = false
              this.$emit('ok')
            })
            .finally(() => {
              this.submitLoading = false
            })
          // }
        } else {
          return false
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
// .specifications {
//   display: flex;
//   align-content: center;
//   .item {
//     width: 130px;
//     margin-right: 11px;
//   }
//   .item_b {
//     margin-left: 10px;
//   }
//   .item_i {
//     display: flex;
//     align-items: center;
//     margin-top: 4px;
//   }
//   /deep/.ant-select-selection--single {
//     width: 120px !important;
//     margin-right: 11px;
//   }
// }
</style>
